/**
 * Provides a reactive check for the tailwind screen type.
 *
 * When window resizes, the screens will change reactively using Vue observable.
 *
 * Contains the width and height of the window, the current tailwind screen class
 * AND a flag for each class that is false if that class is not used.
 *
 */

import Vue from 'vue';
import resolveConfig from 'tailwindcss/resolveConfig';
import _ from 'lodash';
import tailwindConfig from '../../tailwind.config';

const fullConfig = resolveConfig(tailwindConfig);
const tailwindScreens = _.mapValues(fullConfig.theme.screens, (tailwindScreen) => {
    const screen = { min: 0, max: Infinity };
    if (tailwindScreen.max) {
        screen.max = parseInt(tailwindScreen.max, 10);
    }
    if (tailwindScreen.min) {
        screen.min = parseInt(tailwindScreen.min, 10);
    }
    if (!tailwindScreen.min && !tailwindScreen.max) {
        screen.min = parseInt(tailwindScreen, 10);
    }
    return screen;
});

const headers = {
    header: parseInt(fullConfig.theme.spacing.header, 10),
    'header-sm': parseInt(fullConfig.theme.spacing['header-sm'], 10)
};

// Calculates which screen is currently used based on the width, and sets the flags for each
// breakpoint.
function currentScreens() {
    const width = window.innerWidth;
    const current = _.mapValues(tailwindScreens, (screen) => screen.max >= width && screen.min <= width && screen);
    current.header = (current.mobile || !current.md) ? headers['header-sm'] : headers.header;
    return current;
}

const screens = Vue.observable({
    w: window.innerWidth,
    h: window.innerHeight,
    ...(currentScreens())
});

function updateScreens() {
    screens.w = window.innerWidth;
    screens.h = window.innerHeight;
    _.assign(screens, currentScreens());
}
updateScreens();

window.addEventListener('resize', _.debounce(updateScreens, 150));

screens.install = () => {
    Vue.prototype.$screens = screens;
};

export default screens;
